module.exports = __webpack_public_path__ + "img/bg.41d85bd3.jpg";